module.exports = __webpack_public_path__ + "img/ctrl-rz-theta-dagger-stub--i.f3b1a614.svg";